import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DuckDBUnavailableProvider } from './context/LazyDuckDBContext';
import { ThemeProvider } from './context/ThemeContext';
import { FiltersProvider } from './context/FiltersContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { MapProvider } from './context/MapContext';

// Suppress errors from browser wallet extensions (Brave Wallet, MetaMask, etc.)
// These extensions inject window.ethereum into every page and can cause harmless errors
const originalError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString?.() || '';
  if (message.includes('ethereum') || message.includes('Script error')) {
    return; // Silently ignore wallet extension errors
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <MapProvider>
        <DuckDBUnavailableProvider>
          <FiltersProvider>
            <FavoritesProvider>
              <App />
            </FavoritesProvider>
          </FiltersProvider>
        </DuckDBUnavailableProvider>
      </MapProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
